import React from 'react';
import Svg, {SvgProps, Circle, Path} from 'react-native-svg';

const ApplicationStepperTick = (props: SvgProps) => {
    return (
        <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <Circle cx="10" cy="10" r="9.5" fill="white" stroke="#0F8040" />
            <Circle cx="10" cy="10" r="8" fill="#0F8040" />
            <Path
                d="M8.26368 11.5899L12.5987 8.08197L12.5999 8.08327L12.5988 8.08193C12.8555 7.87595 13.2297 7.91502 13.4373 8.17218C13.645 8.42787 13.604 8.80434 13.3488 9.01046L8.26368 11.5899ZM8.26368 11.5899L7.03201 9.84494L7.03197 9.84488C6.84156 9.57593 6.47062 9.51098 6.20164 9.70186L6.20163 9.70186C5.93286 9.89268 5.87 10.264 6.05869 10.533L6.05878 10.5331L7.65787 12.7978L7.6579 12.7979C7.75319 12.9326 7.89952 13.021 8.06241 13.0448L8.06241 13.0448L8.0634 13.0449C8.09042 13.0483 8.11748 13.05 8.14444 13.05C8.28056 13.05 8.41168 13.0039 8.51878 12.9171L8.26368 11.5899ZM8.51882 12.9171L13.3488 9.01048L8.51882 12.9171Z"
                fill="white"
                stroke="white"
                stroke-width="0.1"
            />
        </Svg>
    );
};

export default ApplicationStepperTick;
